// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__W6qRr","spinner-grow":"Loader_spinner-grow__33u7j"};